import { PositionedContainer } from '../../../components'
import styled from 'styled-components'

const PositionedContainerStyled = styled(PositionedContainer)`
  top: var(--content-list-top);
  right: var(--content-list-right);
`

export default PositionedContainerStyled
